import { types } from "./types";
import { instance } from "../utils";
import { triggerNotification } from "../../components";
import { editObligationModal, triggerLoading } from "../forms/actions";
import { getDocumentsByObligations } from "../documents/actions";
import { sortAssessorObligations } from "../../util/sorters";

export const createObligation = ({payload, token, callback}) => dispatch => {
  const url = `/api/obligations`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
  dispatch({ type: types.CREATE_OBLIGATION.START });
  instance
    .post(url, payload, { headers })
    .then(response => {
      dispatch({
        type: types.CREATE_OBLIGATION.SUCCESS,
        payload: response.data
      });
      triggerNotification({
        message: "Creation was successful",
        description: "Obligation successfully created",
        status: "Success"
      });
      callback();
    })
    .catch(error => {
      dispatch({ type: types.CREATE_OBLIGATION.ERROR, payload: error.message });
      triggerNotification({
        message: "Error",
        description: error.message,
        status: "Error"
      });
    });
};

export const getObligationsByUserAndOrg = (user, orgId) => dispatch => {
  return new Promise((resolve, reject) => {
    const url = `/api/obligations/getObligationsByUserAndOrg`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`
    };
    const payload = {
      userId: user.userId,
      orgId: orgId
    };
    dispatch(triggerLoading(true));
    dispatch({ type: types.SET_OBLIGATIONS.START });
    instance
      .post(url, payload, { headers })
      .then(response => {
        if (!user.role.includes("Editor")) {
          dispatch(countObligations(user, orgId))
          dispatch(getDocumentsByObligations(user, orgId));
        };
        dispatch({
          type: types.SET_OBLIGATIONS.SUCCESS,
          payload: sortAssessorObligations(response.data)
        });
        dispatch(triggerLoading(false));
        resolve(response.data);
      })
      .catch(error => {
        dispatch({ type: types.SET_OBLIGATIONS.ERROR, payload: error.message });
        triggerNotification({
          message: "Error",
          description: error.message,
          status: "Error"
        });
        dispatch(triggerLoading(false));
        reject(error);
      });
  });
};

export const checkObligationEditability = ({user, id, action, callback}) => dispatch => {
  const url = `/api/obligations/${id}/${action}/checkObligation`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.CHECK_OBLIGATION.START });
  instance
  .get(url, { headers })
  .then(response => {
    dispatch({ type: types.CHECK_OBLIGATION.SUCCESS, payload: response.status});
    callback(response.status);
    })
  .catch(error => {
    dispatch({ type: types.CHECK_OBLIGATION.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  })
  
}

export const deleteMotherObligation = (id, user) => dispatch => {
  const url = `/api/obligations/${id}/deleteMotherObligation`;
  const headers = {
    "Content-Type": "application/json",
    'Authorization': `Bearer ${user.token}`
  }
  dispatch({ type: types.DELETE_OBLIGATION.START });
  instance
  .delete(url, { headers })
  .then(response => {
    dispatch({ type: types.DELETE_OBLIGATION.SUCCESS, payload: id });
    triggerNotification({});
  })
  .catch(error => {
    dispatch({ type: types.DELETE_OBLIGATION.ERROR, payload: error.message });
    triggerNotification({
      message: "Error",
      description: error.message,
      status: 'Error',
    });
  });
}

export const updateObligationMother =
  (obligationId, payload, user) => dispatch => {
    const url = `/api/obligations/${obligationId}/mother`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`
    };
    dispatch({ type: types.UPDATE_OBLIGATION_MOTHER.START });
    instance
      .patch(url, payload, { headers })
      .then(response => {
        dispatch({ type: types.UPDATE_OBLIGATION_MOTHER.SUCCESS });
        dispatch(editObligationModal(false));
        triggerNotification({});
        dispatch(getObligationsByUserAndOrg(user, user.organization));
      })
      .catch(error => {
        dispatch({
          type: types.UPDATE_OBLIGATION_MOTHER.ERROR,
          payload: error.message
        });
        triggerNotification({
          message: "Error",
          description: error.message,
          status: "Error"
        });
      });
  };

export const updateObligation =
  ({ obligation, formData, user, callback, emailCallback }) =>
  dispatch => {
    const { _id, parent_id, organization } = obligation;
    const url = `/api/obligations/${_id}/${parent_id}/${organization}/uploadToFolder`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`
    };
    dispatch({ type: types.UPDATE_OBLIGATION.START });
    instance
      .post(url, formData, { headers })
      .then(response => {
        dispatch({ type: types.UPDATE_OBLIGATION.SUCCESS, payload: _id });
        triggerNotification({});
        emailCallback(response.data?.emails ?? [])
        return dispatch(getObligationsByUserAndOrg(user, organization)); 
      })
      .then(() => {
        callback(true);
      })
      .catch(error => {
        dispatch({
          type: types.UPDATE_OBLIGATION.ERROR,
          payload: error.message
        });
        triggerNotification({
          message: "Error",
          description: error.message,
          status: "Error"
        });
        callback(true);
      });
  };

export const assignUser =
  ({ newItem, user, organizationId, callback }) =>
  dispatch => {
    const url = `/api/obligations/${newItem._id}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`
    };
    dispatch({ type: types.ASSIGN_USER.START });
    dispatch(triggerLoading(true));
    instance
      .patch(url, newItem, { headers })
      .then(response => {
        dispatch({ type: types.ASSIGN_USER.SUCCESS });
        triggerNotification({});
        return dispatch(getObligationsByUserAndOrg(user, organizationId)); 
      })
      .then(() => {
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.ASSIGN_USER.ERROR, payload: error.message });
        triggerNotification({
          message: "Error",
          description: error.message,
          status: "Error"
        });
      });
  };

export const massAssignObligations =
  ({ targetUserId, oblIds, user, organizationId, callback }) =>
  dispatch => {
    const url = `/api/obligations/massAssignObligations`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user.token}`
    };
    const body = {
      targetUserId,
      items: oblIds
    };
    dispatch({ type: types.MASS_ASSIGN_OBLIGATIONS.START });
    instance
      .post(url, body, { headers })
      .then(response => {
        dispatch({ type: types.MASS_ASSIGN_OBLIGATIONS.SUCCESS });
        triggerNotification({});
        dispatch(getObligationsByUserAndOrg(user, organizationId));
        callback(false);
      })
      .catch(error => {
        dispatch({
          type: types.MASS_ASSIGN_OBLIGATIONS.ERROR,
          payload: error.message
        });
        triggerNotification({
          message: "Error",
          description: error.message,
          status: "Error"
        });
      });
  };

export const countObligations = (user, organizationId) => dispatch => {
  const url = `/api/obligations/${organizationId}/countObligations`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${user.token}`
  };
  dispatch({ type: types.SET_OBLIGATIONS_COUNTERS.START });
  instance
    .get(url, { headers })
    .then(response => {
      dispatch({
        type: types.SET_OBLIGATIONS_COUNTERS.SUCCESS,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch({
        type: types.SET_OBLIGATIONS_COUNTERS.ERROR,
        payload: error.message
      });
    });
};

export const createMessage = (user, obligation_id, message, organization, callback) => dispatch => {
  return new Promise((resolve, reject) => {
    const url = `/api/messages/${obligation_id}/createMessage`;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${user.token}`
    };
    const body = {
      user_id: user.userId,
      message: message,
      organization: organization
    };
    // dispatch(triggerLoading(true));
    dispatch({ type: types.ADD_MESSAGE.START });
    instance
      .post(url, body, { headers })
      .then(response => {
        dispatch({
          type: types.ADD_MESSAGE.SUCCESS,
          payload: response.data
        });
        // dispatch(triggerLoading(false));
        resolve(response.data);
        callback(true); // Move the callback invocation here
      })
      .catch(error => {
        dispatch({ type: types.ADD_MESSAGE.ERROR, payload: error.message });
        triggerNotification({
          message: "Error",
          description: error.message,
          status: "Error"
        });
        // dispatch(triggerLoading(false));
        reject(error);
        callback(false); // Ensure callback is called with false in case of error
      });
  });
};

export const getAllMessages = (user, organization) => dispatch => {
  return new Promise((resolve, reject) => {
    const url = `/api/messages/${organization}/getMessagesByOrg`;
    const headers = {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${user.token}`
    }
    dispatch(triggerLoading(true));
    dispatch({ type: types.SET_MESSAGES.START });
    instance
      .get(url, { headers })
      .then(response => {

        dispatch({
          type: types.SET_MESSAGES.SUCCESS,
          // payload: sortAssessorObligations(response.data)
          payload: response.data
        });
        dispatch(triggerLoading(false));
        resolve(response.data);
      })
      .catch(error => {
        dispatch({ type: types.SET_MESSAGES.ERROR, payload: error.message });
        triggerNotification({
          message: "Error",
          description: error.message,
          status: "Error"
        });
        dispatch(triggerLoading(false));
        reject(error);
      });
  });
};